export const ACCESS_TOKEN = 'Access-Token'
export const ACCESS_TOKEN_SIMPLE = 'Access-Token-Simple'
